import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetMainNews, EResetMainNewsActionType } from './types';

export const resetMainNews: () => TResetMainNews = actionGenerator<EResetMainNewsActionType.Reset>(
  EResetMainNewsActionType.Reset,
);
